'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var DescriptionFormatEnum = /*#__PURE__*/function (DescriptionFormatEnum) {
  DescriptionFormatEnum["HTML"] = "HTML";
  return DescriptionFormatEnum;
}(DescriptionFormatEnum || {});
const toKebab = key => key.replace(/([a-z\d])([A-Z])/g, '$1-$2').toLowerCase();
const styleObjectToString = s => Object.entries(s).reduce((accum, _ref) => {
  let [key, value] = _ref;
  return `${toKebab(key)}:${value};${accum}`;
}, '');
const Description = styled__default["default"].p.withConfig({
  componentId: "sc-cipsk0-0"
})(["margin:0 0 1rem 0;line-height:1.25rem;", " ", " ", ""], _ref2 => {
  let {
    s
  } = _ref2;
  return s ? `${styleObjectToString(s)};` : '';
}, _ref3 => {
  let {
    linkDefault
  } = _ref3;
  return linkDefault ? `a { ${styleObjectToString(linkDefault)} }` : '';
}, _ref4 => {
  let {
    linkHover
  } = _ref4;
  return linkHover ? `a:hover { ${styleObjectToString(linkHover)} }` : '';
});
const TrackingEventDescription = _ref5 => {
  let {
    formattedDescription,
    description,
    s,
    linkDefault,
    linkHover
  } = _ref5;
  const descriptionElement = formattedDescription && formattedDescription.format === DescriptionFormatEnum.HTML && formattedDescription.value ? /*#__PURE__*/React__default["default"].createElement(Description, {
    s: s,
    linkDefault: linkDefault,
    linkHover: linkHover,
    dangerouslySetInnerHTML: {
      __html: formattedDescription.value
    }
  }) : /*#__PURE__*/React__default["default"].createElement(Description, {
    s: s
  }, description);
  return descriptionElement;
};

exports["default"] = TrackingEventDescription;
